<template>
<div>
  <H3>PROJECT FUNDS</h3>

  <div v-if="!data.list.length">No funds found</div>
<table class="fundsview" width="100%">
  <tbody>
    <tr>
      <td width="50%">
<!-- fund list -->

<v-card>
  <v-card-title></v-card-title>
  <v-card-text>

  <table class="dtable-list" v-show="data.list.length">
    <thead>
      <tr>
        <th>Name</th>
        <th>Goal</th>
        <th>Staked</th>
        <th>Stake min</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="el in data.list" @click="select(el)" v-bind:key="el.uuid" class="clickable">
        <td>{{el.title}}</td>
        <td>{{el.goal_amount | currency}}</td>
        <td>{{el.staked}}</td>
        <td>{{el.stake_min | currency}}</td>
        <td>{{el.access}}</td>
      </tr>
    </tbody>
  </table>

  </v-card-text>
</v-card>

<!-- /fund list -->

      </td>

      <td>
<!-- fund content -->

<v-card>
  <v-card-title></v-card-title>
  <v-card-actions class="utils" v-if="isOwner()">
    <v-btn v-if="!editor" @click='create'>New Fund</v-btn>
    <v-btn v-if="!editor && data.list.length" @click='edit'>Edit</v-btn>
  </v-card-actions>
  <v-card-text>

<div class="fund_detail" v-if="data.fund">
  <!-- Form Schema -->
<SchemaForm v-if="editor" :model="data.fund" item="fund" v-on:save="save" v-on:cancel="refresh"/>
  <div class="utils" v-if="isOwner() && editor">
    <button v-if="editor" @click='refresh'>Cancel</button>
    <button v-if="editor" @click='save'>Save</button>
  </div>
  <table v-if="!editor">
    <tbody>
      <tr>
        <td>{{data.fund.title}}</td>
      </tr><tr>
        <td>{{data.fund.content}}</td>
      </tr><tr>
        <td>{{data.fund.goal_amount | currency}}</td>
      </tr><tr>
        <td>{{data.fund.date_goal | formatDate}}</td>
      </tr><tr>
        <td>{{data.fund.date_start | formatDate}}</td>
      </tr><tr>
        <td>{{data.fund.date_target | formatDate}}</td>
      </tr><tr>
        <td>{{data.fund.stake_min | currency}}</td>
      </tr>
      <tr>
      </tr>
    </tbody>
  </table>
  <v-card-actions><v-btn v-if="!editor && data.fund.uuid" @click="fund" >Fund</v-btn></v-card-actions>
</div>

  </v-card-text>
</v-card>

<!-- /fund content -->
      </td>
    </tr>
  </tbody>
</table>

  </div>
</template>

<script>
import router from '../plugins/router'
import axios from '../lib/axios'
var log = console.log;
import SchemaForm from './SchemaForm.vue'

export default {
    components: {
        SchemaForm
    },
    data : function() {
        return {
            config: {
            },
            data: {
                fund: {},
                list: []
            },
            editor: false,
            changed: false
        }
    },
    created : function() {
        this.refresh()
    },
    props: {
        proj : Object
    },
    methods : {
        fund() {
           router.push({ name: 'Fund', params: { 
               proj: this.proj, 
               fund: this.data.fund 
           } }) 
        },
        select : function(rec) {
            if (this.editor) return
            this.data.fund = rec
        },
        isOwner : function() {
            return this.$store.getters.uuid == this.proj._owner
        },
        refresh : function() {
            var self = this
            if (!this.proj.uuid) return
            var url = '/api/filter/funds'+(self.isOwner()?'_all/':'/')
            url += '?_parent='+this.proj.uuid
            self.editor = false
            axios.get(url)
            .then(function (response) {
                if (response.data.status == "error") {
                    log('ERROR','ProjFunds','Request failed',response)
                    //_.delay(self.refresh,600)
                    return false;
                }
                self.data.list = response.data.data
                self.data.fund = response.data.data[0]||{}
            })
            .catch((err) => {
                log('ERROR','ProjFunds', err.message)
            });
        },
        create() {
            this.data.fund = {
            }
            this.editor = true
        },
        edit() {
            this.editor = true
        },
        save(d) {
            var self = this

            var fund = {...self.data.fund, ...d}

            fund._parent = this.proj.uuid

            axios.post( '/api/funds/'+(self.data.fund.uuid||0),
                fund
            ).then(function(r){
                let d = r.data
                if (d.status != "success") throw (d.message || "UNKOWN")

                self.editor=false
                self.data.fund = r.data
                self.refresh()
            })
            .catch(function(e){
              console.log('ERROR','Project:save', 'Attempt failed', e);
self.$store.commit('showMessage', { content: e.message||"ERROR", color: 'error' })
            });

        }
    }
}
</script>

<style>
.item-list {
    margin-left: auto;
    margin-right:auto;
}
.item-list td.title {
    text-align: left;
}
.item-list td.amount {
    text-align: right;
}
</style>
